import script from "./CustomSizeLoading.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomSizeLoading.vue?vue&type=script&lang=ts&setup=true"

import "./CustomSizeLoading.vue?vue&type=style&index=0&id=889bd38e&lang=css"

const __exports__ = script;

export default __exports__